var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangeAvatarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3766 35.8021H4.62268C2.07332 35.8021 0 33.7288 0 31.1794V12.4321C0 9.8827 2.07332 7.80938 4.62268 7.80938H10.898L11.4473 5.9564C11.6715 4.94245 12.5984 4.19824 13.6886 4.19824H26.3115C27.3709 4.19824 28.3085 4.93862 28.5566 5.96563L28.5713 6.0288L29.072 7.80926H35.3773C37.9267 7.80926 40 9.88258 40 12.4319V31.1792C39.9993 33.7288 37.9252 35.8021 35.3766 35.8021ZM4.62268 9.35031C2.92303 9.35031 1.54093 10.7325 1.54093 12.4321V31.1793C1.54093 32.879 2.92315 34.2611 4.62268 34.2611H35.3766C37.0763 34.2611 38.4584 32.8788 38.4584 31.1793V12.4321C38.4584 10.7324 37.0761 9.35031 35.3766 9.35031H27.9049L27.0613 6.34169C26.9835 5.99188 26.6683 5.73846 26.3108 5.73846H13.6877C13.3249 5.73846 13.0167 5.98649 12.9373 6.34253L12.0467 9.35031H4.62268ZM20.0008 31.1447C14.6085 31.1447 10.2215 26.7585 10.2215 21.3669C10.2215 15.9746 14.6084 11.5885 20.0008 11.5885C25.3917 11.5885 29.7779 15.9753 29.7779 21.3669C29.7777 26.7578 25.3916 31.1447 20.0008 31.1447ZM20.0008 13.1286C15.4582 13.1286 11.7625 16.8236 11.7625 21.3662C11.7625 25.9088 15.4584 29.603 20.0008 29.603C24.5426 29.603 28.2369 25.908 28.2369 21.3662C28.2368 16.8236 24.5418 13.1286 20.0008 13.1286ZM34.382 12.2102C33.5961 12.2102 32.9604 12.8473 32.9604 13.6317C32.9604 14.4168 33.596 15.0531 34.382 15.0531C35.167 15.0531 35.8027 14.4167 35.8027 13.6317C35.8019 12.8473 35.1662 12.2102 34.382 12.2102Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeAvatarLogo);
export default __webpack_public_path__ + "static/media/change_avatar_logo.6626bce3e5af337d4d055cfe522bca4d.svg";
export { ForwardRef as ReactComponent };